import React, { useState } from "react";
import SocialPostsExplorerPage from "./pages/SocialPostsExplorerPage";
import SocialMasterConfigurationsPage from "./pages/SocialMasterConfigurationsPage";
import Layout from "../layout/Layout";
import { Routes } from "react-router-dom";
import { useLoginContext } from "../../App";
import { useB2BRoute } from "../b2b-common/hoc/B2BRoute";

const SocialConstext = React.createContext();

const socialRoutes = [
    { path: '/social-posts-explorer', element: <SocialPostsExplorerPage />, visibility: 'private' },
    { path: '/social-master-configurations', element: <SocialMasterConfigurationsPage />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];

const B2BSocial = () => {
    const { sidebarOpen, selectedItem } = useLoginContext();
    const [productsData, setProductsData] = useState(null);

    return (
        <SocialConstext.Provider value={{ productsData, setProductsData }}>
            <Layout sidebarOpen={sidebarOpen} selectedItem={selectedItem}>
                <Routes>
                    {useB2BRoute(socialRoutes)}
                </Routes>
            </Layout>
        </SocialConstext.Provider>
    );
}

export default B2BSocial;
export const useSocialContext = () => React.useContext(SocialConstext);